
















































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import SelectUrl from '@/components/selectUrl/index.vue'
@Component({
  components: {
    PicModal,
    SelectUrl
  }
})
export default class NoticeBar extends Vue {
  @Prop({
    type: Boolean,
    default: () => false
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'noticeBar',
        mode: 'link',
        backgroundColor: '#f67f79',
        color: '#ffffff',
        text: null,
        leftIcon: null,
        url: null
      }
    }
  })
  NoticeBarConfig!: any

  mounted() {

  }


  picChange(e) {
    this.NoticeBarConfig.leftIcon = e[0].url
  }

  deleteFn() {
    this.NoticeBarConfig.leftIcon = null
  }

  urlChange(e) {
    this.NoticeBarConfig.url = e
  }
}
